import { parseDateValue } from '../utils/formatUtils';
export { formatDateShort, formatDate, parseDate };

// Добавить функцию для короткого формата даты
function formatDateShort(timestamp) {
    const date = parseDateValue(timestamp);
    if (!date) return "Нет данных";
    return date.toLocaleDateString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric" });
  }

  // Функция для форматирования даты
const formatDate = (timestamp) => {
    const date = parseDateValue(timestamp);
    return date ? date.toLocaleDateString("ru-RU", { year: "numeric", month: "long", day: "numeric" }) : "Нет данных";
  };

const parseDate = (strDate) => {
    const [y, m, d] = strDate.split("-"); // splits "26-02-2012" or "26/02/2012"
    const date = new Date(y, m - 1, d);
    return date.getTime() / 1000;
  };
  